module.exports = __webpack_public_path__ + "static/media/menu-bar-buttons.45eb68e1.svg";